import { jsx as _jsx } from "react/jsx-runtime";
import { SortByDirection } from '@patternfly/react-table';
import { Button } from '@patternfly/react-core/dist/dynamic/components/Button';
import { Icon } from '@patternfly/react-core/dist/dynamic/components/Icon';
import SortAmountDownIcon from '@patternfly/react-icons/dist/dynamic/icons/sort-amount-down-icon';
import SortAmountUpIcon from '@patternfly/react-icons/dist/dynamic/icons/sort-amount-up-icon';
export function flipDirection(direction) {
    return direction === SortByDirection.asc ? SortByDirection.desc : SortByDirection.asc;
}
var SortBy = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? SortByDirection.asc : _b, _c = _a.onSortChange, onSortChange = _c === void 0 ? function () { return undefined; } : _c;
    return (_jsx(Button, { icon: _jsx(Icon, { size: "md", children: direction === SortByDirection.asc ? _jsx(SortAmountUpIcon, {}) : _jsx(SortAmountDownIcon, {}) }), variant: "plain", onClick: function (e) { return onSortChange(e, flipDirection(direction)); } }));
};
export default SortBy;
//# sourceMappingURL=SortBy.js.map